module.exports = "<div *ngIf=\"reservation?.rate.isRewardNight && message\">\n  <alert-message [translations]=\"messages\" [message]='message'></alert-message>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/user-reservation-check/user-reservation-check.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/user-reservation-check/user-reservation-check.component.html
// module chunks = 0